import type { Severity, WeatherState } from '@/api/dashboard-live';

/**
 * Couleurs du tableau de pilotage.
 *
 * Séries (identité) : palette catégorielle de référence validée daltonisme
 * (ordre fixe, jamais recyclé) — V2 = slot 1 (bleu), V1 = slot 2 (orange),
 * 3e série = slot 3 (aqua). Pas de jaune à côté de l'orange.
 * Statuts : palette réservée (bon / attention / sérieux / critique), toujours
 * accompagnée d'une icône et d'un libellé — jamais la couleur seule.
 */
export const SERIES = {
  light: { v2: '#2a78d6', v1: '#eb6834', third: '#1baf7a', fourth: '#e87ba4', muted: '#a3a29c' },
  dark: { v2: '#3987e5', v1: '#d95926', third: '#199e70', fourth: '#d55181', muted: '#6b6a64' },
};

export const STATUS = {
  good: '#0ca30c',
  warning: '#fab219',
  serious: '#ec835a',
  critical: '#d03b3b',
};

export const SEVERITY_COLOR: Record<Severity, string> = {
  critical: STATUS.critical,
  warning: STATUS.warning,
  info: '#6b8fbf',
};

export const WEATHER_COLOR: Record<WeatherState, string> = {
  sunny: STATUS.good,
  cloudy: STATUS.warning,
  rainy: STATUS.serious,
  stormy: STATUS.critical,
  unknown: '#8a8984',
};

export type ChartPalette = typeof SERIES.light;

/** Valeur (0-100) → couleur de statut pour les jauges de charge */
export function loadColor(p: number | null | undefined, warn = 75, crit = 90): string {
  if (p === null || p === undefined) return '#8a8984';
  if (p >= crit) return STATUS.critical;
  if (p >= warn) return STATUS.warning;
  return STATUS.good;
}

export const SEVERITY_LABEL: Record<Severity, string> = { critical: 'Critique', warning: 'Attention', info: 'Info' };
